export enum AppTypeEnum {
  ApolloELD = 'ApolloELD',
  ATTFleetManagement = 'ATTFleetManagement',
  BigRoad = 'BigRoad',
  BlueInkTech = 'BlueInkTech',
  CargoChief = 'CargoChief',
  OneNetwork = 'OneNetwork',
  CloneOps = 'CloneOps',
  ConvoyTracking = 'ConvoyTracking',
  Coretex = 'Coretex',
  ELD88 = 'ELD88',
  EldMandate = 'EldMandate',
  EldPeak = 'EldPeak',
  ERoad = 'ERoad',
  EmailRateConfirmation = 'EmailRateConfirmation',
  Ezlogz = 'Ezlogz',
  ExpediteAll = 'ExpediteAll',
  ExpediteAllBooking = 'ExpediteAllBooking',
  ExpediteAllTracking = 'ExpediteAllTracking',
  FleetComplete = 'FleetComplete',
  FleetLocate = 'FleetLocate',
  FMELD = 'FMELD',
  FourKitesCarrier = 'FourKitesCarrier',
  GeoTab = 'GeoTab',
  GPSInsight = 'GPSInsight',
  Greenscreens = 'Greenscreens',
  Highway = 'Highway',
  Hirschbach = 'Hirschbach',
  Hos247 = 'Hos247',
  Hutch = 'Hutch',
  ISAAC = 'ISAAC',
  McLeod = 'McLeod',
  McLeodAPIModule = 'McLeodAPIModule',
  Infios = 'Infios',
  MondoTracking = 'MondoTracking',
  Motive = 'Motive',
  MyLogs = 'MyLogs',
  MyCarrierPortal = 'MyCarrierPortal',
  OneStepGPS = 'OneStepGPS',
  Orbcomm = 'Orbcomm',
  Priority1 = 'Priority1',
  Project44 = 'Project44',
  Project44Carrier = 'Project44Carrier',
  QualityLogs = 'QualityLogs',
  RMIS = 'RMIS',
  RevenovaProduction = 'RevenovaProduction',
  RevenovaSandbox = 'RevenovaSandbox',
  SFTP = 'SFTP',
  Samsara = 'Samsara',
  Sonar = 'Sonar',
  Sunnybrook = 'Sunnybrook',
  SuperXELD = 'SuperXELD',
  TQLTrax = 'TQLTrax',
  Tai = 'Tai',
  ThreeGTMS = 'ThreeGTMS',
  ThreePLSystems = 'ThreePLSystems',
  ThreePLSystemsPortal = 'ThreePLSystemsPortal',
  Tive = 'Tive',
  Transporeon = 'Transporeon',
  TruckerToolsCarrier = 'TruckerToolsCarrier',
  TruckX = 'TruckX',
  Turvo = 'Turvo',
  Txt = 'TXT Solutions',
  US1NetworkTMS = 'US1NetworkTMS',
  VerizonConnectFleetTelogis = 'VerizonConnectFleetTelogis',
  VerizonConnectReveal = 'VerizonConnectReveal'
}

export enum AppCategoriesEnum {
  AICommunication = 'AI Communication',
  CarrierVetting = 'Carrier Vetting',
  DeviceTracker = 'Device Tracker',
  ELD = 'ELD',
  Rating = 'Rating',
  TMS = 'TMS',
  TemperatureMonitoring = 'Temperature Monitoring',
  ThirdPartyCarrierTrackingAPI = 'Third Party Carrier Tracking API',
  TrailerTracking = 'Trailer Tracking',
  VisibilityProvider = 'Visibility Provider'
}

/**
 * The type of identifier for the company (e.g. MC#, DOT#)
 */
export enum CompanyIdentifierEnum {
  DOT = 'DOT',
  MC = 'MC',
  Other = 'Other'
}

/**
 * The type of the company (e.g. Broker, Carrier)
 */
export enum CompanyTypeEnum {
  Broker = 'Broker',
  Carrier = 'Carrier'
}

export enum WorkspaceVerificationTypeEnum {
  Basic = 'Basic',
  Trusted = 'Trusted'
}

export interface IWorkspaceApp {
  appMetadata?: {
    allowedEmailAddresses?: string[]

    /**
     * Some apps may have a domain name associated with them.
     * i.e. For RMIS, https://<domainname>.rmissecure.com/_c/std/api/
     */
    domainName?: string

    /**
     * This is true if the user has provided validated credentials. We use this to know what step on the web-client app to show the user when they are enabling a project44 app.
     */
    encodedCredentialsValidated?: boolean

    /**
     * Carrier vetting apps may have provided a specific onboarding URL for the workspace's enabled app
     */
    onboardingURL?: string

    rateConfirmationEmail?: string
  }
  /**
   * The app of {@link AppType}
   */
  appType: AppTypeEnum
  /**
   * Indicates if the app enabled
   */
  enabled: boolean
  /**
   * The user that enabled the app
   */
  enabledByUserID: string

  /**
   * The workspaceID of the app
   */
  workspaceID: string
}

export interface IWorkspace {
  company?: IWorkspaceCompany
  displayName?: string | null
  dot?: string | null
  enterpriseWorkspaceID?: string | null
  id?: string
  isVerified?: boolean
  logo?: string | null
  mcNumber?: string | null
  workspaceType?: string
  workspaceVerificationType?: WorkspaceVerificationTypeEnum | null
  workspacename?: string | null
}

export interface IWorkspaceCompany {
  companyName: string
  id: string
  mcNumber: string
  phoneNumber: string
}

export type TGetConstraintReturn = {
  canEditPage: boolean
  id: string
  type: string
  uuid: string
  workspace: ConstraintWorkspaceType
}

export type ConstraintWorkspaceType = {
  displayName: string
  dot: string | null
  enterpriseWorkspaceID?: string
  id: string
  isEnterpriseWorkspace?: boolean
  isVerified: boolean
  logo: string | null
  mcNumber: string | null
  workspacePage: PageReturnType
  workspaceType: string
  workspacename: string
}

/**
 * The return type for the user page in the "user" graphql query
 */
export type PageReturnType = {
  /**
   * The profile's bio info (a small summary or a short description)
   */
  bio: string | null

  /**
   * The profile's freight preferences (Ex: Dry Van, Reefer, Hazmat)
   */
  freightPreferences: string[]
}

export interface IWorkspaceInvitation {
  expirationDate: number
  invitedBy: {
    countryCode: string
    email: string
    id: string
    name: string
    phone: string
    photo: string
  }
  userID: string
  workspace: {
    displayName: string
    id: string
    logo: string
  }
}

/**
 * The workspace details returned from the DOT or MC number that was entered by the user.
 */
export interface IWorkspaceByDOTOrMCNumberReturnType {
  displayName: string
  dot: string | null
  id: string
  logo: string | null
  mcNumber: string | null
  workspaceType: CompanyTypeEnum
  workspacename: string
}

export interface IMyWorkspace {
  displayName: string
  dot?: string
  enabledApps?: IWorkspaceApp[]
  enterpriseWorkspaceID?: string
  id: string
  isEnterpriseWorkspace?: boolean
  isVerified?: boolean
  logo?: string
  mcNumber?: string
  shipmentsPageSettings?: {
    hideNeedsCarrierShipments: boolean
  }
  workspaceType?: CompanyTypeEnum
  workspaceVerificationType?: WorkspaceVerificationTypeEnum | null
  workspacename: string
}
